import React from 'react'
import styled from 'styled-components'

interface AspectRatioProps {
    width: number
    height: number
    children: React.ReactNode
}

function AspectRatio ({ width, height, children }: AspectRatioProps) {
    return (
        <Wrapper width={width} height={height}>
            <Container>
                {children}
            </Container>
        </Wrapper>
    )
}

export default React.memo(AspectRatio)

// STYLES
const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`

const Wrapper = styled.div<Pick<AspectRatioProps, "width" | "height">>`
    position: relative;

    &:before {
        display: block;
        content: "";
        width: 100%;
        padding-top: ${props => `${props.height / props.width * 100}%`};
    }
`

